document.addEventListener('submit', async function (event) {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('button[type="submit"], input[type="submit"]');
  if (!button) return;

  const originalText = button.tagName === 'INPUT' ? button.value : button.innerText;

  button.disabled = true;

  if (button.tagName === 'INPUT') {
    button.value = 'Adding...';
  } else {
    button.innerText = 'Adding...';
  }

  try {
    const formData = new FormData(form);

    if (!formData.get('quantity')) {
      formData.append('quantity', '1');
    }

    const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Unable to add to cart');
    }

    button.disabled = false;

    if (button.tagName === 'INPUT') {
      button.value = 'Added to Cart';
    } else {
      button.innerText = 'Added to Cart';
    }

    button.classList.add('ajax-added');

    // Refresh cart count after AJAX add-to-cart
    try {
      const cartResponse = await fetch(root + 'cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      const cart = await cartResponse.json();
      const cartCount = cart.item_count;

      // Update ONLY bubble/cart badge counts
      document.querySelectorAll(
        '.cart-count-bubble span, .cart-icon-bubble span, .count-bubble, .header__cart-count-bubble span'
      ).forEach(function (element) {
        element.textContent = cartCount;
      });

      // Hide/remove duplicate plain text cart counts
      document.querySelectorAll(
        '[data-cart-count], .cart-count, .cartCount, .cart-count-text, .header__cart-count'
      ).forEach(function (element) {
        if (!element.closest('.cart-count-bubble, .cart-icon-bubble, .count-bubble, .header__cart-count-bubble')) {
          element.textContent = '';
          element.style.display = 'none';
        }
      });

      // Trigger theme cart refresh events
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart }
      }));

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cart }
      }));

      window.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { cart: cart }
      }));

    } catch (cartError) {
      console.error('Cart refresh failed:', cartError);
    }

    // Force green added-to-cart button style
    button.style.setProperty('background-color', '#4a5b48', 'important');
    button.style.setProperty('border-color', '#4a5b48', 'important');
    button.style.setProperty('color', '#ffffff', 'important');

  } catch (error) {
    button.disabled = false;

    if (button.tagName === 'INPUT') {
      button.value = originalText;
    } else {
      button.innerText = originalText;
    }

    alert(error.message || 'Unable to add to cart. Please try again.');
  }
}, true);

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-toggle-variant]');
  if (!button) return;

  event.preventDefault();

  const targetSelector = button.getAttribute('data-target');
  const target = document.querySelector(targetSelector);

  if (!target) return;

  target.classList.toggle('is-open');

  if (!button.dataset.originalText) {
    button.dataset.originalText = button.textContent.trim();
  }

  button.textContent = target.classList.contains('is-open')
    ? 'Hide Variants'
    : button.dataset.originalText;
}, true);